import React, { Component } from 'react'
import {Alerts} from '../helpers'
import { withRouter } from 'react-router-dom';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
 class Logout extends Component {
    handleLogout =(e) => {
        e.preventDefault();
        sessionStorage.removeItem('isAuthenticated');
        sessionStorage.removeItem('userData');
        sessionStorage.removeItem('userToken');
        Alerts.alertMessage("You have logout successfully.", "Logout !", "success");
        return this.props.history.push('/login');
    }
    render() {
   
        return (
            <div>
                <button className="profile-link" onClick={this.handleLogout}><ExitToAppIcon/> Logout</button>
            </div>
        )
    }
}

export default withRouter(Logout);